import React, { useMemo } from 'react'
import Header from '../component/Header'
import CommonBanner from '../component/CommonBanner'
import Footer from '../component/Footer'
import ExploreResultLocations from '../component/ExploreResultLocations'
import { Card, Col, Container, Row } from 'react-bootstrap'
import PhoneNumber from '../assets/images/phone-number.svg'
import EmailUs from '../assets/images/email-us.svg'
import ConnectUs from '../assets/images/connect-us.svg'
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'
import { usePageContent } from "../hooks/usePageContent";


function ContactUs() {
  const { content, loading, error } = usePageContent("contact-us");

  const contactSection = useMemo(() => {
    if (!content?.contact_us_section) return null;

    if (typeof content.contact_us_section === 'string') {
      try {
        return JSON.parse(content.contact_us_section)
      } catch (err) {
        console.error('Failed to parse contact_us_section JSON:', err)
        return null
      }
    }

    return content.contact_us_section
  }, [content])

  const normalizeHtmlBreaks = (s) =>
    s
      ?.replace(/<span[^>]*>|<\/span>/gi, '')
      .replace(/<br\s*\/?\>/gi, '\n')
      .replace(/\r\n/g, '\n')
      .replace(/\\r\\n/g, '\n');

  const descriptionLines = contactSection?.description
    ? normalizeHtmlBreaks(contactSection.description).split(/\r?\n/).filter(Boolean)
    : [
        'We’re here to help!',
        'Our National Customer Service Team is available 8am - 5pm PST, seven days a week.',
      ]

  const socialLinks = [
    { url: contactSection?.facebook_url, icon: Facebook, alt: 'Facebook' },
    { url: contactSection?.twitter_url, icon: X, alt: 'X' },
    { url: contactSection?.instagram_url, icon: Instagram, alt: 'Instagram' },
    { url: contactSection?.youtube_url, icon: YouTube, alt: 'YouTube' },
    { url: contactSection?.linkedin_url, icon: LinkedIn, alt: 'LinkedIn' },
  ]

  return (
    <>
      <div className='main contact-us-page'>
        <Header/>
        <CommonBanner title="Contact Us" />
        <div className="contact-us common-padding">
          <Container>
              <div className="common-header text-center">
                <h2>{contactSection?.title || 'Get In Touch'}</h2>
                <p>
                  {descriptionLines.map((line, index) => (
                    <React.Fragment key={index}>
                      {line.trim()}
                      {index < descriptionLines.length - 1 ? <br /> : null}
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <Row className="g-4 justify-content-center">
                  <Col md={4}>
                  <Card>
                      <img src={PhoneNumber} alt="" />
                      <p>{contactSection?.call_us_title || 'Phone Number'}</p>
                      <h5>
                        <a href={`tel:${contactSection?.call_us_no || '+19876543210'}`} title="">
                          {contactSection?.call_us_no || '+1 9876543210'}
                        </a>
                      </h5>
                  </Card>
                  </Col>
                  <Col md={4}>
                      <Card>
                          <img src={EmailUs} alt="" />
                          <p>{contactSection?.email_us_title || 'Email Us'}</p>
                          <h5>
                            <a href={`mailto:${contactSection?.email_us_no || 'inquiry@realestate.com'}`} title="">
                              {contactSection?.email_us_no || 'inquiry@realestate.com'}
                            </a>
                          </h5>
                      </Card>
                  </Col>
                  <Col md={4}>
                      <Card>
                          <img src={ConnectUs} alt="" />
                          <p>{contactSection?.connect_title || 'Connect with us'}</p>
                          <ul>
                            {socialLinks.map((social) =>
                              social.url ? (
                                <li key={social.alt}>
                                  <a href={social.url} target="_blank" rel="noreferrer">
                                    <img src={social.icon} alt={social.alt} />
                                  </a>
                                </li>
                              ) : null,
                            )}
                          </ul>
                      </Card>
                  </Col>
              </Row>
          </Container>
      </div>
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default ContactUs


